module.exports = __webpack_public_path__ + "magazine.23ae9d0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/magazine.png
// module id = 1524
// module chunks = 0